<div>
  <div class="table-responsive">
    <table class="table table-sm table-hover" style="font-size: 0.85rem">
      <thead class="text-dark text-center">
        <tr>
          <th class="fs-11" style="max-width: 80px">{{ 'SUBSCRIPTION_PAYMENT.DATE' | translate }}</th>
          <th class="fs-11">{{ 'SUBSCRIPTION_PAYMENT.NO_OF_UNITS' | translate }}</th>
          <th class="fs-11" style="max-width: 160px">
            {{ 'SUBSCRIPTION_PAYMENT.TAXES' | translate }}
            <div *ngIf="taxDistributionSource === taxDistributionEnm.EMPLOYEE && !isMobile" class="subtitle">
              {{ 'SUBSCRIPTION_PAYMENT.WITHHELD_FROM_BUDGET' | translate }}
            </div>
            <div *ngIf="taxDistributionSource === taxDistributionEnm.EMPLOYEE_SALARY && !isMobile" class="subtitle">
              {{ 'SUBSCRIPTION_PAYMENT.WITHHELD_FROM_SALARY' | translate }}
            </div>
            <div *ngIf="taxDistributionSource === taxDistributionEnm.COMPANY && !isMobile" class="subtitle">
              {{ 'SUBSCRIPTION_PAYMENT.COVERED_COMPLETELY_BY_COMPANY' | translate }}
            </div>
          </th>
          <th class="fs-11" style="max-width: 100px">{{ 'SUBSCRIPTION_PAYMENT.PAYMENT' | translate }}</th>
        </tr>
      </thead>
      <tbody>
      <ng-container *ngFor="let payment of autoOrderPayments">
        <ng-container>
          <tr>
            <td class="text-center">
              <ng-container *ngIf="!isMobile; else calendarIcon">
                {{ payment.paymentDate | date:'mediumDate' }}
              </ng-container>
              <ng-template #calendarIcon>
                <div style="color: #4981eb; max-width: 50px;" ngbTooltip="{{ payment.paymentDate | date:'mediumDate' }}"
                     role="button"
                     tabindex="0">
                  <i data-feather="calendar"></i>
                </div>
              </ng-template>
            </td>
            <td class="text-center">
              <div>
                {{ payment.noOfUnits }}
              </div>
            </td>
            <td class="text-center">
              <div *ngIf="payment.taxTotal !== 0">
                <div *ngIf="showTaxesForCompany">
                  {{ payment.taxTotal | number: '1.2-2' }}
                  <span class="ron">RON</span>
                </div>
                <div *ngIf="!showTaxesForCompany">-</div>
              </div>
            </td>
            <td class="text-center">
              <div>
                {{ payment.amountWithVat.toFixed(2) }}
                <span class="ron">RON</span>
              </div>
            </td>
          </tr>
        </ng-container>
      </ng-container>
      </tbody>
      <tfoot>
        <tr>
          <td class="text-center">{{ 'SUBSCRIPTION_PAYMENT.TOTAL' | translate }}</td>
          <td class="text-center">-</td>
          <td class="text-center">
            <div *ngIf="!showTaxesForCompany">-</div>
            <div *ngIf="showTaxesForCompany">
              {{ this.taxesValueTotal.toFixed(2) }}
              <span class="ron">RON</span>
            </div>
          </td>
          <td class="text-center">
            {{ this.paymentValueTotal.toFixed(2) }}
            <span class="ron">RON</span>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>
